export const checkValidity = (value, rules) => {
  /* Check the validity of value with the rules */
  let validateModule = {
    isValid: true,
    message: "",
  };

  if (!rules) {
    return validateModule;
  }

  if (rules.required) {
    validateModule.isValid = value.trim() !== "" && validateModule.isValid;
    if (!(value.trim() !== "")) {
      validateModule.message = "This field is required!";
    }
  }

  // Word-length overrides character length (this will totally NOT bite us in
  // the future).
  let wordsLength = value.trim().split(/\s+/).length;
  if (rules.maxWordsLength || rules.minWordsLength) {
    if (rules.minWordsLength) {
      validateModule.isValid =
        wordsLength <= rules.minWordsLength && validateModule.isValid;
      if (!(wordsLength >= rules.minWordsLength)) {
        validateModule.message =
          "This field requires a minimum word count of " +
          rules.minWordsLength.toString();
      }
    }
    if (rules.maxWordsLength) {
      validateModule.isValid =
        wordsLength <= rules.maxWordsLength && validateModule.isValid;
      if (!(wordsLength <= rules.maxWordsLength)) {
        validateModule.message =
          "Max word count of " + rules.maxWordsLength.toString() + " reached!";
      }
    }

    // Also check against maxLength -- we *MUST* set this hard limit to avoid
    // killing our server.
    if (rules.maxLength) {
      validateModule.isValid =
        value.length <= rules.maxLength && validateModule.isValid;
      if (!(value.length <= rules.maxLength)) {
        validateModule.message =
          "Max character length of " + rules.maxLength.toString() + " reached!";
      }
    }
  } else {
    if (rules.minLength) {
      validateModule.isValid =
        value.length >= rules.minLength && validateModule.isValid;
      if (!(value.length >= rules.minLength)) {
        validateModule.message =
          "This field requires a minimum length of " +
          rules.minLength.toString();
      }
    }
    if (rules.maxLength) {
      validateModule.isValid =
        value.length <= rules.maxLength && validateModule.isValid;
      if (!(value.length <= rules.maxLength)) {
        validateModule.message =
          "Max character length of " + rules.maxLength.toString() + " reached!";
      }
    }
  }

  if (rules.isEmail) {
    /* See
     * https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address */
    const pattern =
      /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    validateModule.isValid = pattern.test(value) && validateModule.isValid;
    if (!pattern.test(value)) {
      validateModule.message = "Please enter a valid email!";
    }
  }

  if (rules.isStrictText) {
    const pattern = /^[A-Za-z ]+$/;
    validateModule.isValid = pattern.test(value) && validateModule.isValid;
    if (!pattern.test(value)) {
      validateModule.message =
        "Please only use characters from A-Z and/or a-z!";
    }
  }

  if (rules.isNumber) {
    const pattern = /^\d+$/;
    validateModule.isValid = pattern.test(value) && validateModule.isValid;
    if (!pattern.test(value)) {
      validateModule.message = "Please enter a valid numerical number!";
    } else {
      if (value < 0) {
        validateModule.isValid = false;
        validateModule.message = "Number should not be negative!";
      }
    }
  }

  if (rules.isFile) {
    if (value > 8000000) {
      validateModule.isValid = false;
      validateModule.message = "File size should be 8 megabytes or less!";
    }
  }

  if (validateModule.isValid && rules.maxWordsLength) {
    let words_remain = rules.maxWordsLength - wordsLength;
    validateModule.message = words_remain.toString() + " words left";
  } else {
    if (validateModule.isValid && rules.maxLength) {
      let char_remain = rules.maxLength - value.length;
      validateModule.message = char_remain.toString() + " characters left";
    }
  }

  return validateModule;
};

export const formValidity = (value, rules) => {
  /* Check validity for submission forms */
  let validateModule = {
    isValid: true,
    message: "",
  };

  if (!rules) {
    return validateModule;
  }

  let wordsLength = 0;

  if (rules.required) {
    if (typeof value === "object") {
      // Only work for array?
      validateModule.isValid = value.length > 0 && validateModule.isValid;
      if (value.length === 0) {
        validateModule.message = "This field is required!";
      }
    } else {
      validateModule.isValid =
        value.trim() !== "" &&
        value.trim() !== "none" &&
        value.trim() !== "0" &&
        validateModule.isValid;
      if (!(value.trim() !== "")) {
        validateModule.message = "This field is required!";
      }
      wordsLength = value.trim().split(/\s+/).length;
    }
  } else {
    validateModule.message = "(optional field)";
  }

  // Word-length overrides character length (this will totally NOT bite us in
  // the future).
  if (rules.maxWordsLength || rules.minWordsLength) {
    if (rules.minWordsLength) {
      validateModule.isValid =
        wordsLength <= rules.minWordsLength && validateModule.isValid;
      if (!(wordsLength >= rules.minWordsLength)) {
        validateModule.message =
          "This field requires a minimum word count of " +
          rules.minWordsLength.toString();
      }
    }
    if (rules.maxWordsLength) {
      validateModule.isValid =
        wordsLength <= rules.maxWordsLength && validateModule.isValid;
      if (!(wordsLength <= rules.maxWordsLength)) {
        validateModule.message =
          "Max word count of " + rules.maxWordsLength.toString() + " reached!";
      }
    }

    // Also check against maxLength -- we *MUST* set this hard limit to avoid
    // killing our server.
    if (rules.maxLength) {
      validateModule.isValid =
        value.length <= rules.maxLength && validateModule.isValid;
      if (!(value.length <= rules.maxLength)) {
        validateModule.message =
          "Max character length of " + rules.maxLength.toString() + " reached!";
      }
    }
  } else {
    if (rules.minLength) {
      validateModule.isValid =
        value.length >= rules.minLength && validateModule.isValid;
      if (!(value.length >= rules.minLength)) {
        validateModule.message =
          "This field requires a minimum length of " +
          rules.minLength.toString();
      }
    }
    if (rules.maxLength) {
      validateModule.isValid =
        value.length <= rules.maxLength && validateModule.isValid;
      if (!(value.length <= rules.maxLength)) {
        validateModule.message =
          "Max character length of " + rules.maxLength.toString() + " reached!";
      }
    }
  }

  if (rules.isEmail) {
    /* See
     * https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address */
    const pattern =
      /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    validateModule.isValid = pattern.test(value) && validateModule.isValid;
    if (!pattern.test(value)) {
      validateModule.message = "Please enter a valid email!";
    }
  }

  if (rules.isStrictText) {
    const pattern = /^[A-Za-z ]+$/;
    validateModule.isValid = pattern.test(value) && validateModule.isValid;
    if (!pattern.test(value)) {
      validateModule.message =
        "Please only use characters from A-Z and/or a-z!";
    }
  }

  if (rules.isNumber) {
    const pattern = /^\d+$/;
    validateModule.isValid = pattern.test(value) && validateModule.isValid;
    if (!pattern.test(value)) {
      validateModule.message = "Please enter a valid numerical number!";
    } else {
      if (value < 0) {
        validateModule.isValid = false;
        validateModule.message = "Number should not be negative!";
      }
    }
  }

  if (rules.isFile) {
    if (value > 8000000) {
      validateModule.isValid = false;
      validateModule.message = "File size should be 8 megabytes or less!";
    }
  }

  if (validateModule.isValid && rules.maxWordsLength) {
    let words_remain = rules.maxWordsLength - wordsLength;
    validateModule.message =
      words_remain.toString() +
      " word" +
      (words_remain !== 1 ? "s" : "") +
      " left";
  } else {
    if (validateModule.isValid && rules.maxLength) {
      let char_remain = rules.maxLength - value.length;
      validateModule.message =
        char_remain.toString() +
        " character" +
        (char_remain !== 1 ? "s" : "") +
        " left";
    }
  }

  return validateModule;
};

export const checkMatchValidity = (target, source, name) => {
  let validateModule = {
    isValid: true,
    message: "",
  };

  if (source !== target) {
    validateModule.isValid = false;
    validateModule.message = name + " does not match!";
  }

  if (name === "Emails") {
    /* See
     * https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address */
    const pattern =
      /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    validateModule.isValid = pattern.test(target) && validateModule.isValid;
    if (!pattern.test(target)) {
      validateModule.message = "Please enter a valid email!";
    }
  }

  return validateModule;
};
